import axios from "axios";

export default async function validateFormDocument(projectName, formName, documentId){
    return await axios.patch(`/project/${projectName}/${formName}/document/${documentId}/validated`);
}